import createAxiosInstance from 'src/utils/createAxiosInstance';
import { CLIENT_PORTAL_API_URL, DATA_TRANSFORMATION_API_URL } from 'src/utils/constants';

export const clientPortalApi = createAxiosInstance(CLIENT_PORTAL_API_URL);
export const dataTransformationApi = createAxiosInstance(DATA_TRANSFORMATION_API_URL);
